// Custom JavaScript for Altesse Studio

document.addEventListener("DOMContentLoaded", function () {
  // Initialiser les carrousels de produits associés
  fixCarouselNavigation();

  // Initialiser les lecteurs vidéo personnalisés
  initCustomVideoPlayers();

  // Initialiser le lecteur audio sur la page produit
  initProductAudioPlayer();

  // Réorganiser les blocs sur mobile pour la page d'accueil
  reorganizeHomepageBlocks();

  // Réorganiser la section des résultats
  reorganizeResultsShowcase(
    "#shopify-section-template--25090203615580__results_showcase_axU8mh",
  );
  reorganizeResultsShowcase(
    "#shopify-section-template--25090203615580__results_showcase_RTdiPh",
  );

  // Réorganiser la section hero
  reorganizeHeroSection();
  
  // Initialiser les boutons cross-sell
  initCrossSellButtons();
  setupCrossSellObserver();
});

/**
 * Initialise les lecteurs vidéo personnalisés avec bouton play/pause
 */
function initCustomVideoPlayers() {
  const videoContainers = document.querySelectorAll(".video-container");

  videoContainers.forEach((container) => {
    const video = container.querySelector("video");
    const overlay = container.querySelector(".video-overlay");
    const playButton = container.querySelector(".video-play-button");
    const playIcon = container.querySelector(
      ".video-play-button svg, .video-play-button .icon",
    );

    if (video && overlay) {
      // Désactiver le gestionnaire d'événement sur l'overlay
      overlay.addEventListener("click", function (e) {
        // Vérifier si le clic est directement sur l'overlay et non sur un de ses enfants
        if (e.target === overlay) {
          toggleVideoPlayback(video, container);
        }
      });

      // Gestionnaire pour le bouton play
      if (playButton) {
        playButton.addEventListener("click", function (e) {
          e.stopPropagation(); // Empêcher la propagation
          toggleVideoPlayback(video, container);
        });
      }

      // Gestionnaire pour l'icône à l'intérieur du bouton play
      if (playIcon) {
        playIcon.addEventListener("click", function (e) {
          e.stopPropagation(); // Empêcher la propagation
          toggleVideoPlayback(video, container);
        });
      }

      // Clic sur la vidéo pour mettre en pause
      video.addEventListener("click", function () {
        toggleVideoPlayback(video, container);
      });

      // Fin de la vidéo
      video.addEventListener("ended", function () {
        container.classList.remove("playing");
      });

      // Désactiver les contrôles natifs
      if (video.hasAttribute("controls")) {
        video.removeAttribute("controls");
      }
    }
  });
}

/**
 * Fonction utilitaire pour basculer la lecture/pause de la vidéo
 */
function toggleVideoPlayback(video, container) {
  if (video.paused) {
    video.play();
    container.classList.add("playing");
  } else {
    video.pause();
    container.classList.remove("playing");
  }
}

/**
 * Corrige la navigation des carrousels
 */
function fixCarouselNavigation() {
  const carousels = document.querySelectorAll(".associated-products__carousel");

  carousels.forEach(function (carousel) {
    // Obtenir les boutons de navigation
    const nextBtn = carousel.querySelector(
      ".carousel__navigation-button--forward",
    );
    const prevBtn = carousel.querySelector(
      ".carousel__navigation-button--back",
    );

    if (!nextBtn || !prevBtn) return;

    // Supprimer tous les gestionnaires d'événements existants
    const newNextBtn = nextBtn.cloneNode(true);
    const newPrevBtn = prevBtn.cloneNode(true);

    nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
    prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);

    // Obtenir le conteneur Swiper
    const swiperContainer = carousel.querySelector(".swiper-container");
    if (!swiperContainer) return;

    // Obtenir l'instance Swiper
    const swiperInstance = swiperContainer.swiper;

    // Si Swiper n'est pas disponible, utiliser une approche alternative
    if (!swiperInstance) {
      const wrapper = swiperContainer.querySelector(".swiper-wrapper");
      const slides = wrapper ? wrapper.querySelectorAll(".swiper-slide") : [];

      if (slides.length === 0) return;

      // Configurer une navigation manuelle
      let currentIndex = 0;
      const totalSlides = slides.length;

      // Fonction pour mettre à jour l'affichage
      function updateSlides() {
        const translateX = -currentIndex * (slides[0].offsetWidth + 20); // 20px est l'espace entre les slides
        wrapper.style.transform = `translate3d(${translateX}px, 0px, 0px)`;
        wrapper.style.transitionDuration = "300ms";
      }

      // Ajouter les gestionnaires d'événements
      newNextBtn.addEventListener("click", function () {
        if (currentIndex < totalSlides - 1) {
          currentIndex++;
          updateSlides();
        }
        console.log("Next clicked, index:", currentIndex);
      });

      newPrevBtn.addEventListener("click", function () {
        if (currentIndex > 0) {
          currentIndex--;
          updateSlides();
        }
        console.log("Previous clicked, index:", currentIndex);
      });
    } else {
      // Utiliser l'API Swiper directement
      newNextBtn.addEventListener("click", function () {
        swiperInstance.slideNext();
        console.log("Next clicked (Swiper API)");
      });

      newPrevBtn.addEventListener("click", function () {
        swiperInstance.slidePrev();
        console.log("Previous clicked (Swiper API)");
      });
    }
  });
}

/**
 * Initialise le lecteur audio sur la page produit
 */
function initProductAudioPlayer() {
  const audioPlayButton = document.querySelector(".audio-play-button");
  if (!audioPlayButton) return;

  const video = document.querySelector("#product-audio");
  const timeDisplay = document.querySelector(".audio-time");

  if (!video || !timeDisplay) return;

  // Réinitialiser l'état du lecteur
  video.pause();
  video.currentTime = 0;

  // Mettre à jour l'affichage du temps
  function updateTimeDisplay() {
    const minutes = Math.floor(video.currentTime / 60);
    const seconds = Math.floor(video.currentTime % 60);
    timeDisplay.textContent = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  // Gérer le clic sur le bouton de lecture
  audioPlayButton.addEventListener("click", function () {
    if (video.paused) {
      // Arrêter tous les autres lecteurs
      document.querySelectorAll("video").forEach((v) => {
        if (v !== video) {
          v.pause();
        }
      });

      // Lire la vidéo
      video
        .play()
        .then(() => {
          // Ajouter la classe playing une fois que la lecture a commencé
          audioPlayButton.classList.add("playing");
          // Changer l'icône pour pause
          const icon = audioPlayButton.querySelector(".icon");
          if (icon) {
            icon.innerHTML =
              '<svg viewBox="0 0 24 24" width="24" height="24"><path d="M14,19H18V5H14M6,19H10V5H6V19Z" fill="currentColor"/></svg>';
            icon.classList.remove("icon-play-fill");
            icon.classList.add("icon-pause");
          }
        })
        .catch((error) => {
          console.error("Erreur lors de la lecture de la vidéo:", error);
        });
    } else {
      // Mettre en pause
      video.pause();
      audioPlayButton.classList.remove("playing");
      // Changer l'icône pour play
      const icon = audioPlayButton.querySelector(".icon");
      if (icon) {
        icon.innerHTML = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_909_10589)">
            <path d="M19.834 8.63396C20.5006 9.01886 20.5007 9.98111 19.834 10.366L6.5823 18.0169C5.91563 18.4018 5.0823 17.9207 5.0823 17.1509V1.84912C5.0823 1.07932 5.91563 0.598194 6.5823 0.983094L19.834 8.63396Z" fill="white"/>
          </g>
          <defs>
            <filter id="filter0_d_909_10589" x="0.0513191" y="0.847656" width="25.3134" height="27.3661" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dy="5.03071"/>
              <feGaussianBlur stdDeviation="2.51536"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_909_10589"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_909_10589" result="shape"/>
            </filter>
          </defs></svg>`;
        icon.classList.add("icon-play-fill");
        icon.classList.remove("icon-pause");
      }
    }
  });

  // Mettre à jour l'affichage du temps pendant la lecture
  video.addEventListener("timeupdate", updateTimeDisplay);

  // Gérer la fin de la lecture
  video.addEventListener("ended", function () {
    audioPlayButton.classList.remove("playing");
    video.currentTime = 0;
    updateTimeDisplay();
    // Remettre l'icône play
    const icon = audioPlayButton.querySelector(".icon");
    if (icon) {
      icon.innerHTML = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_909_10589)">
          <path d="M19.834 8.63396C20.5006 9.01886 20.5007 9.98111 19.834 10.366L6.5823 18.0169C5.91563 18.4018 5.0823 17.9207 5.0823 17.1509V1.84912C5.0823 1.07932 5.91563 0.598194 6.5823 0.983094L19.834 8.63396Z" fill="white"/>
        </g>
        <defs>
          <filter id="filter0_d_909_10589" x="0.0513191" y="0.847656" width="25.3134" height="27.3661" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="5.03071"/>
            <feGaussianBlur stdDeviation="2.51536"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_909_10589"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_909_10589" result="shape"/>
          </filter>
        </defs></svg>`;
      icon.classList.add("icon-play-fill");
      icon.classList.remove("icon-pause");
    }
  });
}

/**
 * Réorganise les blocs de la page d'accueil sur mobile
 * Déplace chaque bloc de texte sous l'image correspondante
 */
function reorganizeHomepageBlocks() {
  // Vérifier si nous sommes sur mobile (max-width: 768px)
  const isMobile = window.innerWidth <= 768;

  // Identifier les sections concernées
  const heroSection = document.querySelector(
    "#shopify-section-template--25090203615580__image_hero_split_iiG7gq",
  );
  const textSection = document.querySelector(
    "#shopify-section-template--25090203615580__double_custom_section_CX3e3z",
  );

  // Vérifier si les deux sections existent
  if (!heroSection || !textSection) return;

  // Identifier les blocs d'images
  const imageBlock1 = heroSection.querySelector(".image-hero-split-item--1");
  const imageBlock2 = heroSection.querySelector(".image-hero-split-item--2");

  // Identifier les blocs de texte
  const textBlock1 = textSection.querySelector(".brush-block.brush-prestige");
  const textBlock2 = textSection.querySelector(".brush-block.brush-beaute");

  // Vérifier si tous les blocs existent
  if (!imageBlock1 || !imageBlock2 || !textBlock1 || !textBlock2) return;

  // Fonction pour réorganiser les blocs
  function reorganize() {
    if (window.innerWidth <= 768) {
      // Créer des conteneurs pour chaque paire image + texte
      const container1 = document.createElement("div");
      container1.className = "mobile-hero-container mobile-hero-container-1";
      container1.style.marginBottom = "30px";

      const container2 = document.createElement("div");
      container2.className = "mobile-hero-container mobile-hero-container-2";

      // Cloner les blocs pour éviter de les supprimer de leur emplacement d'origine
      const imageBlock1Clone = imageBlock1.cloneNode(true);
      const imageBlock2Clone = imageBlock2.cloneNode(true);
      const textBlock1Clone = textBlock1.cloneNode(true);
      const textBlock2Clone = textBlock2.cloneNode(true);

      // Ajouter les blocs aux conteneurs
      container1.appendChild(imageBlock1Clone);
      container1.appendChild(textBlock1Clone);

      container2.appendChild(imageBlock2Clone);
      container2.appendChild(textBlock2Clone);

      // Masquer les blocs originaux
      imageBlock1.style.display = "none";
      imageBlock2.style.display = "none";
      textBlock1.style.display = "none";
      textBlock2.style.display = "none";

      // Supprimer les conteneurs existants s'ils existent déjà
      const existingContainers = document.querySelectorAll(
        ".mobile-hero-container",
      );
      existingContainers.forEach((container) => container.remove());

      // Ajouter les nouveaux conteneurs après la section hero
      heroSection.parentNode.insertBefore(container1, textSection);
      heroSection.parentNode.insertBefore(container2, textSection);
    } else {
      // Rétablir l'affichage normal sur desktop
      imageBlock1.style.display = "";
      imageBlock2.style.display = "";
      textBlock1.style.display = "";
      textBlock2.style.display = "";

      // Supprimer les conteneurs mobiles s'ils existent
      const mobileContainers = document.querySelectorAll(
        ".mobile-hero-container",
      );
      mobileContainers.forEach((container) => container.remove());
    }
  }

  // Exécuter la réorganisation initiale
  reorganize();

  // Réorganiser à chaque redimensionnement de la fenêtre
  window.addEventListener("resize", reorganize);
}

/**
 * Réorganise la section des résultats en déplaçant l'image au-dessus du contenu
 * @param {string} sectionSelector - Le sélecteur CSS de la section à réorganiser
 */
function reorganizeResultsShowcase(sectionSelector) {
  // Identifier la section des résultats
  const resultsSection = document.querySelector(sectionSelector);

  if (!resultsSection) return;

  // Identifier les conteneurs d'image et de contenu
  const imageContainer = resultsSection.querySelector(
    ".results-showcase__image-container",
  );
  const contentContainer = resultsSection.querySelector(
    ".results-showcase__content",
  );

  // Vérifier si les deux conteneurs existent
  if (!imageContainer || !contentContainer) return;

  // Obtenir le parent qui contient les deux éléments
  const gridContainer = resultsSection.querySelector(".results-showcase__grid");

  if (!gridContainer) return;

  // Fonction pour réorganiser les éléments
  function reorganize() {
    // Sur mobile uniquement (max-width: 768px)
    if (window.innerWidth <= 768) {
      // Déplacer l'image avant le contenu
      gridContainer.insertBefore(imageContainer, contentContainer);
    } else {
      // Sur desktop, s'assurer que le contenu est avant l'image (ordre original)
      // Vérifier si l'image est actuellement avant le contenu
      if (
        imageContainer.compareDocumentPosition(contentContainer) &
        Node.DOCUMENT_POSITION_FOLLOWING
      ) {
        // Si oui, remettre le contenu avant l'image
        gridContainer.insertBefore(contentContainer, imageContainer);
      }
    }
  }

  // Exécuter la réorganisation initiale
  reorganize();

  // Réorganiser à chaque redimensionnement de la fenêtre
  window.addEventListener("resize", reorganize);
}

/**
 * Réorganise la section hero en déplaçant le conteneur de texte après le div inner
 */
function reorganizeHeroSection() {
  // Identifier la section hero
  const heroSection = document.querySelector(
    "#shopify-section-template--25090203615580__image_hero_RhjMVY",
  );

  if (!heroSection) return;

  // Identifier le conteneur de texte et le div inner
  const textContainer = heroSection.querySelector(
    ".image-hero__text-container-wrapper",
  );
  const innerContainer = heroSection.querySelector(".image-hero__inner");

  // Vérifier si les deux éléments existent
  if (!textContainer || !innerContainer) return;

  // Fonction pour réorganiser les éléments
  function reorganize() {
    // Sur mobile uniquement (max-width: 768px)
    if (window.innerWidth <= 768) {
      // Vérifier si le conteneur de texte est déjà un enfant direct du div inner
      if (textContainer.parentNode === innerContainer) {
        // Déplacer le conteneur de texte après le div inner
        innerContainer.parentNode.insertBefore(
          textContainer,
          innerContainer.nextSibling,
        );
      }
    } else {
      // Sur desktop, vérifier si le conteneur de texte n'est pas à sa place d'origine
      if (textContainer.parentNode !== innerContainer) {
        // Remettre le conteneur de texte à sa place d'origine dans le div inner
        innerContainer.appendChild(textContainer);
      }
    }
  }

  // Exécuter la réorganisation initiale
  reorganize();

  // Réorganiser à chaque redimensionnement de la fenêtre
  window.addEventListener("resize", reorganize);
}

// Gestion des cross sells panier

function initCrossSellButtons() {
  const crossSellButtons = document.querySelectorAll('.cross-sells__item-add[data-quick-view-trigger]');
  
  crossSellButtons.forEach(button => {
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    
    newButton.addEventListener('click', handleCrossSellAddToCart);
  });
}

function handleCrossSellAddToCart(e) {
  e.preventDefault();
  
  const button = this;
  const productUrl = button.getAttribute('data-product-url');
  
  if (!productUrl) {
    console.error('[Cross-sell] Missing product URL');
    return;
  }
  
  setButtonLoadingState(button, true);
  
  fetchProductData(productUrl)
    .then(product => processProductData(product, button))
    .catch(error => handleError(error, button, 'Failed to load product data'));
}

function fetchProductData(productUrl) {
  return fetch(`${productUrl}.js`)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return response.json();
    });
}

function processProductData(product, button) {
  const availableVariant = product.variants.find(variant => variant.available);
  
  if (!availableVariant) {
    handleError(new Error('No available variants'), button, 'Ce produit n\'est plus disponible');
    return;
  }
  
  addVariantToCart(availableVariant.id)
    .then(() => {
      triggerCartRefresh();
      setButtonLoadingState(button, false);
    })
    .catch(error => handleError(error, button, 'Erreur lors de l\'ajout au panier'));
}

function addVariantToCart(variantId, quantity = 1) {
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);
  
  return fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`Cart API Error: ${response.status}`);
    }
    return response.json();
  });
}

function triggerCartRefresh() {
  const appEvent = new CustomEvent('apps:product-added-to-cart');
  document.dispatchEvent(appEvent);
  
  const cartEvents = [
    'cart:refresh',
    'cart:updated',
    'product:added-to-cart'
  ];
  
  cartEvents.forEach(eventName => {
    const event = new CustomEvent(eventName);
    document.dispatchEvent(event);
  });
  
  if (window.theme?.cart?.refresh) {
    window.theme.cart.refresh();
  }
  
  if (typeof refreshCart === 'function') {
    refreshCart();
  }
}

function setButtonLoadingState(button, isLoading) {
  if (isLoading) {
    button.classList.add('loading');
    button.disabled = true;
  } else {
    button.classList.remove('loading');
    button.disabled = false;
  }
}

function handleError(error, button, userMessage) {
  console.error('[Cross-sell Error]', error);
  alert(userMessage);
  setButtonLoadingState(button, false);
}

function setupCrossSellObserver() {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const hasCrossSell = addedNodes.some(node => 
          node.nodeType === Node.ELEMENT_NODE && 
          (node.classList?.contains('cross-sells') || node.querySelector?.('.cross-sells'))
        );
        
        if (hasCrossSell) {
          setTimeout(initCrossSellButtons, 100);
        }
      }
    });
  });
  
  const cartContainers = document.querySelectorAll('.quick-cart, .cart-drawer, [data-cart-drawer]');
  cartContainers.forEach(container => {
    observer.observe(container, {
      childList: true,
      subtree: true
    });
  });
}

document.addEventListener("variant:change", function () {
  setTimeout(fixCarouselNavigation, 100);
});

document.addEventListener("cart:refresh", function () {
  setTimeout(initCrossSellButtons, 100);
});


document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function () {
    const fullUrl = window.location.href;
    if ( !!document.querySelector(".typeform-en") === true && !fullUrl.includes('/en/') ){
      document.querySelector(".typeform-en").remove();
    } else if ( !!document.querySelector(".typeform-fr") === true && fullUrl.includes('/en/') ){
      document.querySelector(".typeform-fr").remove();
    }
  }, 500);
});
